// commands/index.ts
export * from "prosemirror-commands";
